import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import CohortDetailsComponent from "./component";
import { toastr } from "react-redux-toastr";
import { useParams } from "react-router-dom";

const CohortViewContainer = (props) => {
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [cohortDetailsData, setCohortDetailsData] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteType, setDeleteType] = useState(null);
  const [deleteIds, setDeleteIds] = useState([]);
  const [deleteMessage, setDeleteMessage] = useState("");
  const [deleting, setDeleting] = useState(false);
  const [shouldResetFields, setShouldResetFields] = useState(false);

  // 🔥 API Load Function
  const LoadCohortViewDetails = () => {
    setLoading(true);

    props.getDataFromAPI(
      `/dashboard/api/v2/admin/vendingmachines/vm-cohorts/${id}`,
      "GET",
      undefined,
      (response) => {
        setCohortDetailsData(response);
        setLoading(false);
      },
      () => {
        setLoading(false);
      },
      true
    );
  };

  // 🔥 Initial load
  useEffect(() => {
    LoadCohortViewDetails();
  }, []);

  // 🔥 Delete Popup open type setter
  const handleDeleteClick = (userId) => {
    setDeleteType("user");
    setDeleteIds([userId]);
    setDeleteMessage("Are you sure you want to remove this user?");
    setShowDeleteModal(true);
  };

  const handleVmDeleteClick = (vmIds) => {
    setDeleteType("vm");
    
    // Ensure vmIds is always an array
    let ids = Array.isArray(vmIds) ? vmIds : [vmIds];
    
    // Convert all IDs to strings
    ids = ids.map(id => id.toString());
    
    setDeleteIds(ids);
    
    // Show proper message
    if (ids.length === 1) {
      setDeleteMessage(`Are you sure you want to remove VM ID: ${ids[0]}?`);
    } else {
      setDeleteMessage(`Are you sure you want to remove ${ids.length} vending machine(s)?`);
    }
    
    setShowDeleteModal(true);
  };

  // 🔥 Delete API caller
  const confirmDelete = () => {
    setDeleting(true);

    if (deleteType === "user") {
      CohortUserRemove(deleteIds[0]);
    } else if (deleteType === "vm") {
      CohortBatchVMRemove(deleteIds);
    }
  };

  // 🔥 User delete API
  const CohortUserRemove = (userId) => {
    props.getDataFromAPI(
      `/dashboard/api/v2/admin/vendingmachines/vm-cohorts/${id}/users/${userId}`,
      "DELETE",
      undefined,
      () => {
        toastr.success("User removed successfully");
        handleDeleteComplete();
      },
      () => {
        toastr.error("Error removing user");
        handleDeleteComplete();
      },
      true
    );
  };

  // 🔥 VM delete API - Send as array of strings ["1234", "1232"]
  const CohortBatchVMRemove = (vmIds) => {
    // vmIds is already an array of strings from handleVmDeleteClick
    // No need to convert, just send as-is
    
    props.getDataFromAPI(
      `/dashboard/api/v2/admin/vendingmachines/vm-cohorts/${id}/vendingmachines`,
      "DELETE",
      { vmIds: vmIds }, // Array of strings like ["1145", "1146", "1388"]
      () => {
        toastr.success(`${vmIds.length} Vending Machine(s) removed successfully`);
        handleDeleteComplete();
      },
      () => {
        toastr.error("Error removing VM(s)");
        handleDeleteComplete();
      },
      true
    );
  };

  // 🔥 Reset + reload
  const handleDeleteComplete = () => {
    setDeleting(false);
    setShowDeleteModal(false);

    setDeleteType(null);
    setDeleteIds([]);
    setDeleteMessage("");

    // Set flag to reset fields in component
    setShouldResetFields(true);

    // 🔥 Re-fetch updated cohort details  
    LoadCohortViewDetails();
  };

  // 🔥 Reset the reset flag after it's been used
  const handleResetFieldsComplete = () => {
    setShouldResetFields(false);
  };

  return (
    <CohortDetailsComponent
      loading={loading || deleting}
      cohortDetailsData={cohortDetailsData}
      showDeleteModal={showDeleteModal}
      setShowDeleteModal={setShowDeleteModal}
      handleDeleteClick={handleDeleteClick}
      handleVmDeleteClick={handleVmDeleteClick}
      confirmDelete={confirmDelete}
      deleteMessage={deleteMessage}
      deleting={deleting}
      shouldResetFields={shouldResetFields}
      onResetFieldsComplete={handleResetFieldsComplete}
    />
  );
};

export default connect(
  () => ({}),
  { getDataFromAPI }
)(CohortViewContainer);